<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  
    data(){
            return {}
        }
}
</script>

<style>
#app {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  
  color: #2c3e50;

}
</style>



// WEBPACK FOOTER //
// src/App.vue